import React from 'react';
import IntlProvider from '../../components/Common/IntlProvider';
import config from '../../config';

export default function IntlProviderContainer(props) {
  return <IntlProvider locale={config.common.defaultLocale} {...props} />;
}
